import { IPayPackage } from "@/common/entity/PayPackage";
import { request, UrlPath } from "@/request";

/**
 * @param isShowToast 请求异常或请求{@link Response.code 响应数据code}不为0时是否使用{@link Message.error}显示对应错误信息
 */
function payPkgs(isShowToast: boolean = true): Promise<IPayPackage[]> {
    return request<IPayPackage[]>(UrlPath.payPkgs, isShowToast);
}

export const OtherApi = {
    payPkgs,
}
